<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <TransitionRoot as="template" :show="open">
        <Dialog as="div" class="fixed z-10 inset-0 overflow-y-auto" @close="cancel()">
            <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                    <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </TransitionChild>

                <!-- This element is to trick the browser into centering the modal contents. -->
                <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                    <div class="relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                        <div>
                            <div v-if="type == 'info'" class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100">
                                <InformationCircleIcon class="h-6 w-6 text-blue-500" aria-hidden="true" />
                            </div>
                            <div  v-if="type == 'success'" class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                                <CheckCircleIcon class="h-6 w-6 text-green-500" aria-hidden="true" />
                            </div>
                            <div v-if="type == 'warning'" class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100">
                                <ExclamationIcon class="h-6 w-6 text-yellow-500" aria-hidden="true" />
                            </div>
                            <div v-if="type == 'error'" class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
                                <ExclamationCircleIcon class="h-6 w-6 text-red-500" aria-hidden="true" />
                            </div>
                            <div class="mt-3 text-center sm:mt-5">
                                <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900">{{ title }}</DialogTitle>
                                <div class="mt-2">
                                    <p class="text-sm text-gray-500">{{ message }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                            <button type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:col-start-2 sm:text-sm" @click="confirm()">{{ confirmationLabel }}</button>
                            <button type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm" @click="cancel()" ref="cancelButtonRef">{{ cancelLabel }}</button>
                        </div>
                    </div>
                </TransitionChild>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script>
// TODO: ADAM Gdzie ten komponent jest wywoływany? Mógłby być testowo na ikonce torby w TopMenu i jak przekazać do niego przykłądowe dane.
import { ref } from 'vue'
import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import {
    CheckCircleIcon,
    ExclamationIcon,
    ExclamationCircleIcon,
    InformationCircleIcon
} from '@heroicons/vue/outline'

export default {
    name: "Modal",
    components: {
        Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        CheckCircleIcon,
        ExclamationIcon,
        ExclamationCircleIcon,
        InformationCircleIcon,
    },
    setup() {
        const open = ref(false);
        const title = ref(null);
        const message = ref(null);
        const type = ref('info');
        const onConfirmation = ref('ok');
        const onCancel = ref('cancel');
        const confirmationLabel = ref('OK');
        const cancelLabel = ref('Cancel');

        return {
            open,
        }
    },
    mounted() {
        this.emitter.on('modal', (data) => {
            this.title = data.title;
            this.message = data.message;
            this.type = data?.type || 'info';
            this.open = true;
            this.onConfirmation = data?.onConfirmation || 'ok';
            this.onCancel = data?.onCancel || 'cancel';
            this.confirmationLabel = data?.confirmationLabel || 'OK';
            this.cancelLabel = data?.cancelLabel || 'Cancel';
        });
    },
    methods: {
        confirm() {
            this.open = false;
            this.emitter.emit(this.onConfirmation || 'ok');
        },
        cancel() {
            this.open = false;
            this.emitter.emit(this.onCancel || 'cancel');
        }
    }
}
</script>
